module.exports = require('./dist/jstz.js');



//////////////////
// WEBPACK FOOTER
// ./~/jstz/index.js
// module id = 1662
// module chunks = 0